<template>
  <div class="RemindButton" >
    <!-- 拉新  未登录/ 登录_非vip( 非充值过vip )_拉新-->
    <template v-if="
        !isLogin ||
        ( isLogin && registerDay <= 3 && isNoVip && status ) ||
        ( isLogin && registerDay >3 && userInfo.is_inviter != -1 && isNoVip && status ) ">
      <div
        @click="navigatorTo(REMIND_TYPE.invite)"
        class="RemindButton RemindButtonInvite">
        不花一分钱 增加下载次数
        <div class="button" >去领取 </div>
      </div>
    </template>

    <!-- 充值 非会员
      登录_非vip( 非充值过vip )_未拉新
      登录_vip(充值过)_
    -->
    <template
      v-if="
      (isLogin && registerDay >3 && userInfo.is_inviter == -1 && isNoVip && status)||
       (isLogin && vipAboutToExpireList.length == 0 && isNoVip == false && status)"
    >
      <div
        @click="navigatorTo(REMIND_TYPE.pay)"
        class="RemindButtonPay RemindButtonPay">
        <div class="title">畅享商用授权</div>
        <div class="desc">仅需要一杯冰奶茶的价格</div>
        <div class="button" >去体验
        </div>
      </div>
    </template>

    <template
      v-if="isLogin && vipAboutToExpireList.length && isNoVip == false && status"
    >
      <!-- 登录_过期七天内  -->
      <div
        @click="navigatorTo(REMIND_TYPE.renew)"
        class="RemindButtonPay RemindButtonRenew">
        <div class="title">您的VIP会员即将到期</div>
        <div class="desc">再也不能无忧无虑的下载图片</div>
        <div class="button">去续费
        </div>
      </div>
    </template>


  </div>
</template>

<script>
import {fnInviteFriend, fnLogin, fnRouter, fnUser} from "@/fn";
import {PAGE_PATH} from "@/constant/PAGE_PATH";
import {tag} from "@/utils/statUtil";
import {mapState} from "vuex";
import {VIP_STATE} from "@/constant/VIP";
import {PAY_BUSINESS, PAY_COMPANY, PAY_PERSON} from "@/constant/PATH";

/* 按钮类型 */
const REMIND_TYPE = {
  invite: 'invite',
  pay: 'pay',
  renew: 'renew',
}

export default {
  name: "RemindButton",
  computed: {
    ...mapState('user',
      [
        'userInfo',
        'personVipState',
        'personVipInfo',
        'businessVipState',
        'businessVipInfo',
        'companyVipState',
        'companyVipInfo',
        'isLogin'
      ]
    ),
  },
  props: {
    entry: {
      type: String | Number,
      default: 5
    }
  },
  data() {
    return {

      registerDay:0,  // 注册天数


      vipExpire: -1,
      vipExpireInfo:[],
      isVip: false,
      isExpire: false,
      isNoVip: false,

      vipAboutToExpireList:[],  // 会员到期列表
      REMIND_TYPE,
      status:false
    }
  },
  watch:{
    isLogin(n, o) {
      if (n || !n) {
        setTimeout(()=>{
          this.init();
        },500)
      } else {
      }
    }
  },
  mounted() {
    this.init();
    fnUser.checkUserRegisterDay();
  },
  methods: {
    navigatorTo(type) {
      if (type === REMIND_TYPE.invite) {
        fnInviteFriend.inviteFriendEntry(this.entry)
      } else if (type === REMIND_TYPE.pay) {
        tag('充值:详情页充值广告:图片:click')
        fnRouter.navigationTo(PAGE_PATH.PAY_BUSINESS)
      } else if (type === REMIND_TYPE.renew) {
        tag('充值:详情页续费按钮:图片:click')
        if (this.vipAboutToExpireList.length){
          fnRouter.navigationTo(this.vipAboutToExpireList[0].url)
        }
      }
    },
    init() {
      if(fnLogin.checkLogin()){
        this.isNoVip = fnUser.checkUserIsNoVip();
        this.vipAboutToExpireList = fnUser.checkUserIsAboutToExpire();
        this.registerDay = fnUser.checkUserRegisterDay();
        console.log(this.registerDay)

        this.status = true;
      }
    },
  }
}
</script>

<style lang="scss" scoped>


@mixin RemindButton(
  $buttonColor:transparent,
  $buttonBg:transparent,
  $buttonBgHover:transparent,
) {
  width: 434px;
  height: 62px;
  line-height: 62px;
  background: #2A3F52;
  border-radius: 8px;
  position: relative;
  font-size: 16px;
  font-weight: bold;
  color: #35D0BA;
  letter-spacing: 1px;
  padding-left: 46px;
  box-sizing: border-box;
  margin-top: 20px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .button {
    width: 144px;
    height: 62px;
    background: $buttonBg;
    border-radius: 8px;
    @include Position(1, 2, 0, 0);
    font-size: 16px;
    font-weight: bold;
    color: $buttonColor;
    text-align: center;
    line-height: 62px;
    transition: all 0.3s ease-in;
    @include ElementHover('', $buttonBgHover);
  }

  .title {
    font-size: 14px;
    color: #FFFFFF;
    line-height: 19px;
    letter-spacing: 1px;
  }
  .desc {
    font-size: 16px;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 21px;
    letter-spacing: 1px;
  }
}

.RemindButtonInvite {
  @include RemindButton(
      #FFFFFF, #35D0BA, #30BBA8
  );
}

.RemindButtonPay {
  @include RemindButton(
      #D87D00,
      #FFE0A1,
      rgba(255, 224, 161, 0.9)
  );
  padding-left: 32px;
  background: linear-gradient(224deg, #FF5E9F 0%, #FF906F 100%);
}

.RemindButtonRenew {
  @include RemindButton(
      #FFE198,
      #323757,
      rgba(50, 55, 87, 0.9)
  );
  background: linear-gradient(180deg, #FCEBB7 0%, #F7D380 100%);
  padding-left: 32px;

  .title, .desc {
    color: #1D2155;
  }

  .desc {
    font-weight: bold;
  }
}
</style>

